import React from 'react';
import '../App.css';
// import HeroComponent from './HeroComponent';
import "./Card.css";

function Card() {
  return (
    <>
    <div className="white-bar"></div>
      <div className="card-row">
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="card-front">
              <p><strong>My name is Anirudh. Here's more about me!</strong></p>
            </div>
            <div className="card-back">
              <p>
                I'm a University of Waterloo and Wilfrid Laurier student in the Double Degree CS/BBA program.<br/>
                I'm interested in space, writing, history, sports,and <b>contributing positively to your organization.</b> <br/>
                I'm committed to leadership, service, and honor. 
              </p>
            </div>
          </div>
        </div>

        <div className = "flip-card">
      <div className = "flip-card-inner">
        <div className = "card-front">
          <p><strong>Work Experience</strong></p>
        </div>
    <div  className = "card-back">
      <p>Jr. Software Engineer at FinacleSoft (AequitasAI Division) - Django, Angular, PostgreSQL <br/>
        Jr. Software Developer at Avant Tech (Scotiabank Division) - Node.js, Spring Boot <br/>
        Accountancy Intern at Mercury Tax <br/>
        To learn more, please download my resume at the top of the page!</p>
    </div>
    </div>
    </div>

    
    </div>
      <div className="card-row">
        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="card-front">
              <strong>Technical Skills</strong>
            </div>
            <div className="card-back">
              <p>
                Python (experience with Django,pandas, numpy, sklearn, matplotlib) <br />
                JavaScript, CSS, React.js, Node.js<br />
                Java (experience with Spring Boot, Swing) <br />
                C, C++ <br />
                C#, .NET <br />
                SQL (PostgreSQL) <br />
                Azure (AZ-900, DP-900, AI-102)<br/>
                Bash <br />
              </p>
            </div>
          </div>
        </div>

        <div className="flip-card">
          <div className="flip-card-inner">
            <div className="card-front">
              <strong>Professional Skills</strong>
            </div>
            <div className="card-back">
              <p>
                Team management & morale boosting <br />
                Strong written and verbal communication <br />
                Eager-to-learn personality <br />
                Ability to work well under pressure <br />
                Experience with pipeline work <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;